import { CommonModule, Location, isPlatformBrowser } from '@angular/common';
import {
 Component,
 Inject,
 InjectionToken,
 Input,
 OnChanges,
 OnInit,
 PLATFORM_ID,
 SimpleChanges,
 inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { WINDOW } from '../../search-result.module';
import { DatepickerService } from '@shared/services/datepicker.service';

@Component({
 selector: 'iho-plp-breadcrumb',
 templateUrl: './plp-breadcrumb.component.html',
 styleUrls: ['./plp-breadcrumb.component.scss'],
 standalone: true,
 imports: [RouterLink, FormsModule, CommonModule],
})
export class PlpBreadcrumbComponent implements OnInit {
 @Input() searchName?: string;
 datePickerService = inject(DatepickerService);
 router = inject(Router);
 @Input({
  transform: (value: any) => {
   if (value) {
    return value.itemListElement.map((item: any) => {
     return item.item;
    });
   }
  },
 })
 JsonBreadcrumb: any;
 isEcolodge = false;
 route = inject(ActivatedRoute);

 constructor(@Inject(WINDOW) private window: Window) {}

 ngOnInit(): void {}
 navToPlp(url: string, ev: Event) {
  ev.preventDefault();
  this.datePickerService.setState(false);
  this.router.navigate([url]);
 }
}
